module.exports = __webpack_public_path__ + "static/media/barrier.27109716.gif";